import React from 'react';
import './index.scss';

const CircularProgress = ({ progress = 0, size = 30 }) => {
  return (
    <div
      className="circular-progress"
      style={{
        '--progress': progress,
        width: size,
        height: size,
      }}
    >
      <div className="circular-progress-inner">
        <span>{Number(progress).toFixed(0)}%</span>
      </div>
    </div>
  );
};

export default CircularProgress;
